module.exports = __webpack_public_path__ + "img/blue_179.3a7a6e2b.png";